import { Ascendente, ParentVM } from 'civil-status/view-models/step-form';

export const transformerAscendente = (dataSubject?: ParentVM): Ascendente | undefined => {
  if (!dataSubject) {
    return undefined;
  }

  return {
    gradoParentela: dataSubject.generality?.relationship || undefined,
  };
};
